import { Controller } from "@hotwired/stimulus";

// The Hubspot conversations SDK is loaded in by GTM and is also
// relatively slow to initialise. GTM loads in these libraries 
// right and the end of the page load. All this code is basically a 
// wrapper to allow the button to summon the chat to work even if
// hubspot is still loading or initialising.
//
export default class HubspotController extends Controller {
  openWhenReady = false;

  static targets = ["button"];

  declare buttonTarget: HTMLButtonElement;

  connect() {
    if (window.HubSpotConversations) {
      this.onConversationsApiReady();
    }

    window.hsConversationsOnReady = [this.onConversationsApiReady.bind(this)];
  }

  onConversationsApiReady() {
    this.buttonTarget.removeAttribute("disabled");
    this.buttonTarget.removeAttribute("data-tooltip");

    if (this.openWhenReady) {
      this._doOpen();
    }
  }

  openChatWidget() {
    if (this.buttonTarget.disabled) {
      return;
    }

    if (window.HubSpotConversations) {
      this._doOpen();
    } else {
      this.openWhenReady = true;
    }
  }

  _doOpen() {
    window.HubSpotConversations.widget.open();
  }
}
